import React from 'react';
import { StageScaleView } from '@/framework';
import { MainLayerRenderWrapper } from '@/layers/main-layer/views/layer';
import { ILayerProps } from '@/version-types';
import { DrawPenCursor } from '../components/draw-pen-cursor';
import { DrawPenPath } from '../components/draw-pen-path';
import { useEliminateDraw } from '../hooks/use-draw';
import { useEliminateInit } from '../hooks/use-init';
import { useEliminatePenState } from '../states/eliminate-pen-state';

export const EliminatePen: React.FC<{ originLayer: ILayerProps; originIndex: number }> = ({
    originLayer,
    originIndex,
}) => {
    useEliminateInit();
    const eliminateConfig = useEliminatePenState()((state) => state.eliminateConfig);
    const {
        watermarkMaskURL,
        textMaskURL,
        autoRecognizeWatermark,
        autoRecognizeText,
        isWatermarkMaskUsed,
        isTextMaskUsed,
    } = eliminateConfig;
    const { drawPenType, penCursorSize, penVisible, drawingPath, drawPathList, mousePosition } = useEliminateDraw();

    /* ATTENTION: 统一在外层进行缩放，内部按照实际尺寸进行绘制 */
    return (
        <StageScaleView originIndex={originIndex} style={{ overflow: 'hidden' }}>
            <MainLayerRenderWrapper isNavigator layer={originLayer}>
                <DrawPenPath
                    drawingPath={drawingPath}
                    drawPathList={drawPathList}
                    watermarkMaskURL={autoRecognizeWatermark && !isWatermarkMaskUsed ? watermarkMaskURL : ''}
                    textMaskURL={autoRecognizeText && !isTextMaskUsed ? textMaskURL : ''}
                />
            </MainLayerRenderWrapper>
            <DrawPenCursor show={penVisible} size={penCursorSize} penType={drawPenType} position={mousePosition} />
        </StageScaleView>
    );
};
